import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { Button, H1, H2, Text } from "@salt-ds/core";

import store from "src/store/store";

import { openEmailClient } from "src/utils/UtilityFunction";
import {
  ACH_ERROR_PAGE_H1,
  ACH_ERROR_PAGE_H2,
  ACH_ERROR_PAGE_TXT,
  CONTACTUS,
} from "src/utils/Constants";

const ACHErrorPage: React.FC = () => {
  const secData = useSelector(
    (state: ReturnType<typeof store.getState>) => state.getSecData.value,
  );

  const contentTargetEnrollment =
    secData?.secDataDetails?.content?.contentTargetEnrollment;

  const mailtoLink = openEmailClient(contentTargetEnrollment);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex items-center justify-center">
      <div className="h-[248px] flex-col  justify-center gap-10 inline-flex ">
        <div className="h-44 bg-white flex-col justify-start items-start gap-6 inline-flex">
          <div className=" h-8 flex-col justify-start  inline-flex mt-[24px]">
            <H1>{ACH_ERROR_PAGE_H1}</H1>

            <div className="h-6 flex-col justify-start items-start gap-2 inline-flex mt-[24px]">
              <H2>{ACH_ERROR_PAGE_H2}</H2>
            </div>
            <div className="h-4 flex-col justify-start items-start gap-2 inline-flex mt-[24px]">
              <Text>{ACH_ERROR_PAGE_TXT}</Text>
            </div>
          </div>
        </div>
        <div className="h-8 justify-start items-center gap-4 inline-flex ">
          <Button
            variant="cta"
            className="normal-case bg-customBlue h-8 rounded"
            onClick={() => (window.location.href = mailtoLink)}
          >
            {CONTACTUS}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ACHErrorPage;
